import useAuth from '../../context/auth.context.jsx';

// 'pro' | 'premium' | null — the passive "you're paying" cue shown outside
// the subscription pages themselves (appBar.jsx, sidebar.jsx, planChip.jsx).
export default function usePlanAccent() {
    const { userData } = useAuth();
    const plan = userData?.entitlements?.plan;
    return plan === 'PREMIUM' || plan === 'PRO' ? plan.toLowerCase() : null;
}
